<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="tableData"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
            @sort="sort"
        >
            <template slot="photo" slot-scope="{ item }">
                <div v-if="!!item.photo" :style="`background-image: url(${item.photo}); border-radius: 50%; width: 100px; height: 100px; background-position: center; background-repeat: no-repeat; background-position: center; background-size: cover;`">
                    <b-btn class="delete-photo-button" variant="link" @click="deletePhoto(item)" size="sm"><i class="fa fa-trash"></i></b-btn>
                </div>
            </template>
            <template slot="assignations" slot-scope="data">
                <b-btn v-if="!!data.item.assignations.length" size="sm" variant="info" @click="seeAssignations(data.item)">
                    <b-badge variant="light">
                        {{data.item.assignations.length}}
                    </b-badge>
                </b-btn>
            </template>
    
            <template slot="actions" slot-scope="data">
                <b-button size="sm" variant="primary" v-if="userCan('update-user')" :disabled="!!data.item.deleted_at" @click="updateUser(data.item)"><i class="fa fa-pencil"></i></b-button>
                <b-button size="sm" variant="danger" v-if="userCan('delete-user')" :disabled="!!data.item.deleted_at" @click="removeUser(data.item)"><i class="fa fa-trash"></i></b-button>
                <b-button size="sm" variant="warning" v-if="userCan('reset-password')" :disabled="!!data.item.deleted_at" @click="resetPassword(data.item)"><i class="fa fa-retweet"></i></b-button>
                <b-button size="sm" variant="success" v-if="!!data.item.deleted_at && userCan('restore-user')" class="ml-2" title="Activar" @click="activate(data.item.id)"><i class="fa fa-check"></i></b-button>
                <b-button size="sm" variant="primary" v-if="userCan('view-user-log')"><i class="fa fa-list-ul" @click="watchLog(data.item.id)"></i></b-button>
                <b-button size="sm" variant="primary" v-if="userCan('update-user-photo')" @click="updatePhoto(data.item)"><i class="fa fa-camera"></i></b-button>                
            </template>
        </app-data-table>
    </div>
</template>
<script>
import fields from './fields';
import Paginator from '../../../UI/Controls/Paginator/Paginator.vue';
export default {
    components: {
        appPaginator: Paginator
    },
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: fields,
            userLogs: []
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];

            return this.data.data.map(item => ({...item, classes: !!item.deleted_at? ['alert', 'alert-danger']: ''}));
        }
    },
    methods: {
        sort(sortConf) {
            this.$emit('sort', sortConf);
        },
        onChangePage(page){
            this.$emit('change-page', page);
        },
        updateUser(data){
            this.$emit('update-user', data);
        },
        removeUser(data){
            this.$emit('remove-user', data);
        },
        resetPassword(data){
            this.$emit('reset-password', data);
        },
        seeAssignations(data){
            this.$emit('see-assignations', data);
        },
        activate(userId) {
            this.$emit('activate', userId);
        },
        watchLog(userId) {
            this.$emit('watch-log', userId);
        },
        updatePhoto(user) {
            this.$emit('update-photo', user);
        },
        deletePhoto(user) {
            this.$emit('delete-photo', user);
        }
    }
}
</script>
<style lang="css">
    .delete-photo-button {
        position: relative;
        top: 0;
        left: 80%;
        margin-top: -8px;
    }
</style>